"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchingProtocolsError = exports.ProcessingError = exports.ContinueError = void 0;
const BaseError_1 = require("./BaseError");
const ErrorCodes_1 = require("./ErrorCodes");
class ContinueError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.ContinueError, message);
    }
}
exports.ContinueError = ContinueError;
class ProcessingError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.ProcessingError, message);
    }
}
exports.ProcessingError = ProcessingError;
class SwitchingProtocolsError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.SwitchingProtocolsError, message);
    }
}
exports.SwitchingProtocolsError = SwitchingProtocolsError;
//# sourceMappingURL=InformationErrors.js.map